import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _AcceptPaymentsFilledIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.8535 11.2703C20.5771 11.9166 21.663 11.9166 22.3866 11.2703H23.0401V18.0811C23.0401 19.6932 21.7506 21 20.1601 21H2.88001C1.28942 21 0 19.6932 0 18.0811V11.2703H19.8535ZM4.32001 15.6486C3.78982 15.6486 3.36001 16.0843 3.36001 16.6216C3.36001 17.159 3.78982 17.5946 4.32001 17.5946H6.24002C6.77021 17.5946 7.20002 17.159 7.20002 16.6216C7.20002 16.0843 6.77021 15.6486 6.24002 15.6486H4.32001ZM8.64003 15.6486C8.10983 15.6486 7.68002 16.0843 7.68002 16.6216C7.68002 17.159 8.10983 17.5946 8.64003 17.5946H12.48C13.0102 17.5946 13.44 17.159 13.44 16.6216C13.44 16.0843 13.0102 15.6486 12.48 15.6486H8.64003Z"
        fill={iconColor}
      />
      <Path
        d="M21.1201 3C21.6503 3 22.0801 3.43561 22.0801 3.97297V7.46199L22.3613 7.17694C22.7362 6.79697 23.3439 6.79697 23.7188 7.17694C24.0937 7.55691 24.0937 8.17282 23.7188 8.55279L21.7988 10.4987C21.4239 10.8787 20.8162 10.8787 20.4413 10.4987L18.5213 8.55279C18.1464 8.17282 18.1464 7.55691 18.5213 7.17694C18.8962 6.79697 19.5039 6.79697 19.8788 7.17694L20.1601 7.46199V3.97297C20.1601 3.43562 20.5899 3 21.1201 3Z"
        fill={iconColor}
      />
      <Path
        d="M19.2629 3.48649C19.2233 3.64215 19.2001 3.80478 19.2001 3.97297V5.91892C18.7087 5.91892 18.2175 6.10905 17.8426 6.48902C17.0927 7.24896 17.0927 8.48077 17.8426 9.24071L17.9251 9.32432H0V6.40541C0 4.79333 1.28942 3.48649 2.88001 3.48649H19.2629Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const AcceptPaymentsFilledIcon = assignWithoutSideEffects(_AcceptPaymentsFilledIcon, {
  componentId: 'AcceptPaymentsFilledIcon',
});

export default AcceptPaymentsFilledIcon;
